import templateUrl from "emun.filemanager/upload-file-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import config from "emun.filemanager/file-manager.config";

class controller {
	constructor($scope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = config;
		$ctrl.title = "Upload File...";
		$ctrl.visibilityOptions = config.visibilityOptions;
		$ctrl.visibility = config.visibility;

		//$ctrl.folders = new AutoQuery({
		//	url: 'QueryDocumentFolders.json',
		//	hideLeftNav: true,
		//	orderBy: 'FolderName',
		//	autoLoad: true,
		//	pageSize: 1000
		//});
		$ctrl.folder = options.folder;
		if ($ctrl.folder.parentFolderName) {
			$ctrl.folderName =
				$ctrl.folder.parentFolderName + "/" + $ctrl.folder.folderName;
		} else {
			$ctrl.folderName = $ctrl.folder.folderName;
		}
		$ctrl.folderId = options.folderId;
		$ctrl.entityId = options.entityId;

		if ($ctrl.entityId && $ctrl.options.realm.indexOf("Vendor") == -1) {
			$ctrl.visibility = "Private";
		}
		$ctrl.description = "";
		$ctrl.upload = function ($files) {
			if ($files && $files.length) {
				let req = {
					request: {
						realm: $ctrl.options.realm,
						description: $ctrl.description,
						tags: {
							FolderId: $ctrl.folderId,
							Visibility: $ctrl.visibility,
							Parent: $ctrl.entityId,
							PriceList: $ctrl.priceList ? $ctrl.priceList : undefined
						}
					},
					files: $files,
					urls: []
				};

				$ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
					$ctrl.media = response.data.media[0];
					$ctrl.$broadcast("$documentUploaded");
					$ctrl.$dismiss();
				});
			}
		};
	}
}
export default {
	open(options) {
		return modals.open(
			Object.assign(
				{
					templateUrl,
					resolve: {
						options: () => options
					},
					bindToController: true,
					controller,
					controllerAs: "$ctrl",
					size: "lg"
				},
				(options || {}).modal
			)
		).result;
	}
};
